// 省略号loading组件
import { CSSProperties } from "react";
import styles from "./index.module.scss";

export interface UKLoadingDotsProps {
  interval?: number;
  className?: string;
  style?: CSSProperties;
}

const UKLoadingDots = ({
  interval = 500,
  className,
  style,
}: UKLoadingDotsProps) => {
  const animationDuration = `${interval * 3 / 1000}s`;

  return (
    <span
      className={`${styles.loadingDots} ${className || ''}`}
      style={{
        letterSpacing: 1,
        animationDuration,
        ...style
      }}
    />
  );
};

export default UKLoadingDots;
